export default "__VITE_ASSET__CLSEKQ10__"